<template>
  <div class="change-password-page">
    <!-- 返回 -->
    <div class="back-link" @click="goBack">
      <img
        class="back-icon"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
        alt=""
      />
      <span>返回</span>
    </div>

    <!-- 页面标题 -->
    <h1 class="page-title">修改密码</h1>

    <!-- 表单卡片 -->
    <div class="form-card">
      <!-- 新密码 -->
      <div class="form-group">
        <label class="form-label">设置新密码</label>
        <div class="input-wrapper">
          <input
            autocomplete="new-password"
            :type="showPassword ? 'text' : 'password'"
            class="form-input"
            placeholder="请设置密码（至少6位数）"
            v-model.trim="form.password"
            @keydown="$utils.handleKeydownFilter"
            maxlength="20"
          />
          <img
            v-if="showPassword"
            @click="showPassword = false"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login1.png"
            alt=""
          />
          <img
            v-else
            @click="showPassword = true"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login2.png"
            alt=""
          />
        </div>
      </div>

      <!-- 确认密码 -->
      <div class="form-group no-label">
        <div class="input-wrapper">
          <input
            autocomplete="new-password"
            :type="showConfirmPassword ? 'text' : 'password'"
            class="form-input"
            placeholder="再次输入密码"
            v-model.trim="form.confirmPassword"
            @keydown="$utils.handleKeydownFilter"
            maxlength="20"
          />
          <img
            v-if="showConfirmPassword"
            @click="showConfirmPassword = false"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login1.png"
            alt=""
          />
          <img
            v-else
            @click="showConfirmPassword = true"
            class="eye-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login2.png"
            alt=""
          />
        </div>
      </div>

      <!-- 保存按钮  :disabled="!canSubmit" -->
      <button class="submit-btn" @click="handleSubmit">保存</button>
    </div>
    <!-- 页脚 -->
    <FooterModel
      style="position: fixed; bottom: 0; left: 0; right: 0"
    ></FooterModel>
  </div>
</template>

<script>
import { change } from "@/api/index";
import FooterModel from "@/components/FooterModel.vue";
export default {
  name: "ChangePassword",
  components: {
    FooterModel,
  },
  data() {
    return {
      form: {
        password: "",
        confirmPassword: "",
      },
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    // 是否可以提交
    canSubmit() {
      if (!this.form.password || this.form.password.length < 6) return false;
      if (this.form.password !== this.form.confirmPassword) return false;
      return true;
    },
  },
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.replace({ path: "/", force: true });
    },
    async handleSubmit() {
      if (!this.form.password) {
        this.$toast.error("请输入新密码");
        return;
      }
      if (!this.form.confirmPassword) {
        this.$toast.error("请再次输入密码");
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$toast.error("两次输入密码不一致");
        return;
      }

      if (this.form.password.length < 6 || this.form.password.length > 20) {
        this.$toast.error("密码长度需为6-20位");
        return;
      }
      try {
        // 模拟修改密码接口
        await change({
          password: this.form.password,
        }).then((res) => {
          this.$toast.success("密码修改成功");
          this.$router.replace("/");
        });
      } catch (err) {
        this.$toast.error("修改密码失败，请稍后重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .change-password-page {
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    padding: 3.75rem 1.25rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .back-link {
      width: 100%;
      max-width: 38rem;
      margin-bottom: 2.625rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-size: 1.25rem;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 1.625rem;
        height: 1.625rem;
        margin-right: 1.1rem;
      }
    }

    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      margin-bottom: 3rem;
      text-align: center;
    }

    .form-card {
      width: 100%;
      max-width: 38rem;
      background: #fff;
      border-radius: 1.4rem;
      padding: 3.1875rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 116, 252, 0.2);
      box-sizing: border-box;

      .form-group {
        margin-bottom: 1.5rem;

        &.no-label {
          margin-top: -0.5rem;
          margin-bottom: 2.5rem;
        }

        .form-label {
          display: block;
          font-size: 0.875rem;
          color: #333;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          height: 3.875rem;
          background: #fff;
          border: 1px solid #e5e5e7;
          border-radius: 0.75rem;
          transition: border-color 0.2s;

          &:focus-within {
            border-color: #0074fc;
          }

          .form-input {
            flex: 1;
            height: 100%;
            border: none;
            outline: none;
            padding: 0 1rem;
            font-size: 1rem;
            color: #101424;
            background: transparent;

            &::placeholder {
              color: #e5e5e7;
            }
          }

          .eye-icon {
            width: 1.5rem;
            height: 1.5rem;
            margin-right: 1rem;
            cursor: pointer;
            user-select: none;
          }
        }
      }

      .submit-btn {
        width: 100%;
        height: 3.875rem;
        background: #0074fc;
        border: none;
        border-radius: 0.75rem;
        color: #fff;
        font-size: 1.5rem;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.2s;

        &:disabled {
          background: #c4c6cc;
          cursor: not-allowed;
        }

        &:not(:disabled):hover {
          background: #0066e0;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .change-password-page {
    min-height: 100vh;
    width: 100%;
    background: #ffffff;
    overflow-y: auto;
    padding: 4rem 0 16rem; /* 顶部与底部留白与登录页一致 */
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, sans-serif;
    position: relative;

    /* 返回链接（与登录页 .back-home 风格统一） */
    .back-link {
      width: 42.375rem;
      margin: 0 auto 4rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-weight: 600;
      font-size: 1.75rem;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 1.1rem;
        object-fit: contain;
      }
    }

    /* 页面标题（与登录页 .login-title 一致） */
    .page-title {
      width: 42.375rem;
      margin: 0 auto 3rem;
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
    }

    /* 表单卡片（与登录页 .login-form 一致） */
    .form-card {
      width: 42.375rem;
      margin: 0 auto;
      padding: 3rem 2.25rem;
      background: #ffffff;
      border-radius: 1.5rem;
      box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.05);
      border: 1px solid rgba(0, 116, 252, 0.2);
      box-sizing: border-box;

      /* 表单项组（与登录页 .form-item 一致） */
      .form-group {
        margin-bottom: 1.25rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        /* 无标签的表单组（确认密码）—— 正常间距即可 */
        &.no-label {
          margin-top: 0;
        }

        .form-label {
          font-size: 2rem;
          color: #1a1a1a;
          font-weight: 600;
        }

        .input-wrapper {
          position: relative;
          width: 100%;

          .form-input {
            width: 100%;
            height: 6.5rem;
            background: #ffffff;
            border-radius: 1.5rem;
            border: 1px solid #e5e5e7;
            font-size: 1.75rem;
            color: #333333;
            padding: 0 2rem;
            outline: none;
            box-sizing: border-box;
            transition: border-color 0.2s;

            &:focus {
              border-color: #1677ff;
            }

            &::placeholder {
              color: #c4c6cc;
            }
          }

          /* 密码眼睛图标（与登录页 .password-eye 一致） */
          .eye-icon {
            position: absolute;
            right: 2rem;
            top: 50%;
            transform: translateY(-50%);
            width: 3rem;
            height: 3rem;
            cursor: pointer;
            user-select: none;
            object-fit: contain;
          }
        }
      }

      /* 保存按钮（与登录页 .login-btn 一致） */
      .submit-btn {
        width: 100%;
        height: 6.5rem;
        background-color: #c4c6cc;
        color: #ffffff;
        font-weight: 500;
        font-size: 2.25rem;
        text-align: center;
        border: none;
        border-radius: 1.5rem;
        cursor: not-allowed;
        transition: background-color 0.2s;
        box-sizing: border-box;

        &:not(:disabled) {
          background-color: #1677ff;
          cursor: pointer;
        }

        &:not(:disabled):hover {
          background-color: #4096ff;
        }
      }
    }
  }
}
</style>